import { atom } from "jotai";

export const isDirtyAtom = atom(false); 